module.exports = __webpack_public_path__ + "./images/orange_marker.7e9cfe.svg";